export const WOUND_PHOTO_COLUMNS = [
  { Header: "MRN #", accessor: "mrn", sortable: true },
  { Header: "First name", accessor: "firstName", sortable: true },
  { Header: "Last name", accessor: "lastName", sortable: true },
  { Header: "Gender", accessor: "gender", sortable: true },
  { Header: "Age", accessor: "age", sortable: true, width: "150px" },
  { Header: "DOB", accessor: "dob", sortable: true, width: "180px" },
];

export const NEW_ADMISSION_COLUMNS = [
  { Header: "MRN #", accessor: "mrn", sortable: true },
  { Header: "First name", accessor: "firstName", sortable: true },
  { Header: "Last name", accessor: "lastName", sortable: true },
  { Header: "Gender", accessor: "gender", sortable: true },
  { Header: "Age", accessor: "age", sortable: true, width: "150px" },
  { Header: "DOB", accessor: "dob", sortable: true, width: "180px" },
  { Header: "Admission date", accessor: "admissionDate", sortable: true, width: "300px" },
  { Header: "Discharge date", accessor: "dischargeDate", sortable: true, width: "300px" },
];

export const NEW_WOUND_COLUMN = [
  { Header: "MRN #", accessor: "mrn", sortable: true },
  { Header: "First name", accessor: "firstName", width: "200px", sortable: true },
  { Header: "Last name", accessor: "lastName", width: "200px", sortable: true },
  { Header: "Age", accessor: "age", width: "150px", sortable: true },
  { Header: "DOB", accessor: "dob", width: "180px", sortable: true },
  { Header: "Admission date", accessor: "admissionDate", width: "230px", sortable: true },
  { Header: "Discharge date", accessor: "dischargeDate", width: "230px", sortable: true },
  { Header: "Wound photo", accessor: "woundPicture", type: "image", sortable: false },
  { Header: "Wound name", accessor: "woundName", width: "450px", sortable: true },
  { Header: "Re-Eval counter label", accessor: "reEvalCount", width: "200px", sortable: true },
  { Header: "Workflow status", accessor: "assessmentStage", width: "200px", sortable: true },
  { Header: "History/Cause", accessor: "cause", width: "250px", sortable: true },
  { Header: "Anatomy", accessor: "anatomy", width: "200px", sortable: true },
  { Header: "Photo taken by", accessor: "identifiedBy", width: "200px", sortable: true },
  { Header: "Last assessed", accessor: "lastAssessedDate", width: "230px", sortable: true },
  { Header: "Wound acquired", accessor: "woundAcquired", width: "150px", sortable: true },
];
